import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import Loading from "../../Components/Loading";
import { renderPrice } from "../../Utils/functions";
import { useBookMarks } from "./Hooks";

const BookMark = () => {
  const { data, navigate, loading } = useBookMarks();

  return (
    <div className="">
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">نشان شده ها</p>
        </div>
      </header>
      <div className="container mt-3">
        {loading ? (
          <>
            <div className="row">
              <Loading count={4} col={12} />
            </div>
          </>
        ) : (
          <>
            {data.data.length == 0 ? (
              <>
                <div id="book-mark-list mt-5">
                  <div className="row mt-5">
                    <p className="text-center mt-5">علاقه مندی یافت نشد</p>
                  </div>
                </div>
              </>
            ) : (
              data.data.map((item, count) => {
                return (
                  <Link
                    key={count}
                    className="col-12"
                    to={`/list/${item.slug}`}
                  >
                    <div className="vertical-card">
                      <div className="image-card">
                        <img src={item?.main_image?.url} />
                      </div>
                      <div className="content-vertical-card">
                        <h6>{item.title}</h6>
                        <p className="city-province">{`${item?.province?.title}، ${item?.city?.title}`}</p>
                        <p className="price-card">{renderPrice(item.price)}</p>
                      </div>
                    </div>
                  </Link>
                );
              })
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BookMark;
